export const pluralMappings = {
  company: {
    '=1': 'company',
    other: 'companies',
  },
  credit: {
    '=1': 'credit',
    other: 'credits',
  },
  user: {
    '=1': 'user',
    other: 'users',
  },
};
